import bowser from 'bowser';
// Import AppContainer container
import AppContainer from 'containers/AppContainer';
import IE9 from 'containers/AppContainer/IE9';
// Import dependencies
import React from 'react';
import { render } from 'react-dom';
// RequestAnimationFrame
import 'utils/RequestAnimationFramePolyfill';
// Import stores
import initializeStores from './stores';

// Global scope
window._      = require('lodash');
window.moment = require('moment');


// Initialize Stores
const stores = initializeStores();

/**
 * Render Mediahub function
 */
(function renderMediahub() {

  // Find our mount node
  const mountNode = document.querySelector('#root');

  // Declare our appComponent
  const isOldIE      = bowser.msie && bowser.version <= 9;
  const appComponent = isOldIE
    ? <IE9 />
    : <AppContainer stores={stores} />;

  // Render our App component
  render(appComponent, mountNode);
})();
